export function getSafeRedirectPath(
  redirect: string | null | undefined,
  fallback = '/onboarding/space'
) {
  if (!redirect) return fallback;
  if (!redirect.startsWith('/') || redirect.startsWith('//')) return fallback;
  return redirect;
}

export function buildInviteRedirectPath(token: string, prefillName?: string) {
  const trimmedName = prefillName?.trim();
  const searchParams = new URLSearchParams();

  if (trimmedName) {
    searchParams.set('prefillName', trimmedName);
  }

  const query = searchParams.toString();
  return `/onboarding/join/${token}${query ? `?${query}` : ''}`;
}

export function buildInviteAuthSearch(params: {
  token: string;
  displayName?: string;
  spaceName?: string;
}) {
  const searchParams = new URLSearchParams();
  const trimmedName = params.displayName?.trim();

  searchParams.set('mode', 'signup');
  searchParams.set('redirect', buildInviteRedirectPath(params.token, trimmedName));

  if (trimmedName) {
    searchParams.set('displayName', trimmedName);
  }

  if (params.spaceName) {
    searchParams.set('inviteSpaceName', params.spaceName);
  }

  return searchParams.toString();
}
